import { Neutrals } from '../color-palette/colors';

import { TypographyI } from './typogrphy.interface';

export const Typography: TypographyI = {
  fontFamily: '"Roboto", "Inter", sans-serif',
  title: {
    fontWeight: 700,
    fontSize: '30px',
    color: Neutrals[900],
  },
  h1: {
    fontWeight: 500,
    fontSize: '24px',
    color: Neutrals[900],
  },
  h2: {
    fontWeight: 500,
    fontSize: '20px',
    color: Neutrals[900],
  },
  h3: {
    fontWeight: 600,
    fontSize: '16px',
    color: Neutrals[900],
  },
  h4: {
    fontWeight: 400,
    fontSize: '14px',
    color: Neutrals[900],
  },
  body: {
    fontSize: '16px',
    fontWeight: 400,
    color: Neutrals[900],
  },
  highlight: {
    fontSize: '14px',
    fontWeight: 600,
    color: Neutrals[900],
  },
  info: {
    fontSize: '14px',
    fontWeight: 300,
    color: Neutrals[900],
  },
  caption1: {
    fontWeight: 400,
    fontSize: '10px',
    color: Neutrals[700],
  },
  caption2: {
    display: 'block',
    fontWeight: 400,
    fontSize: '12px',
    color: Neutrals[700],
  },
  label: {
    display: 'block',
    fontWeight: 400,
    fontSize: '13px',
    color: Neutrals[700],
  },
  header: {
    fontWeight: 500,
    fontSize: '14px',
    color: Neutrals[900],
  },
  sectionLabel: {
    display: 'block',
    fontWeight: 800,
    fontSize: '11px',
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    lineHeight: 1.2,
    color: Neutrals[600],
  },
  cardTitle: {
    display: 'block',
    fontWeight: 800,
    fontSize: '16px',
    letterSpacing: '-0.01em',
    color: Neutrals[900],
  },
  cardTitleSm: {
    display: 'block',
    fontWeight: 700,
    fontSize: '15px',
    color: Neutrals[900],
  },
  unitSuffix: {
    fontWeight: 600,
    fontSize: '11px',
    color: Neutrals[400],
  },
  metricValue: {
    display: 'block',
    fontWeight: 800,
    fontSize: '18px',
    letterSpacing: '-0.02em',
    lineHeight: 1.1,
    color: Neutrals[900],
  },
  columnHeader: {
    display: 'block',
    fontWeight: 700,
    fontSize: '12px',
    letterSpacing: '0.06em',
    textTransform: 'uppercase',
    color: Neutrals[600],
  },
  fontWeightSemiBold: 600,
  lineHeightTight: 1.2,
  lineHeightHeading: 1.25,
  underlineOffset: '0.2em',
};

